import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { PropsWithChildren } from 'react';

import { cn } from '@/app/shared/lib/cn';

export type DrawerProps = PropsWithChildren<{
  isOpen?: boolean;
  onClose?: () => void;
  className?: string;
  title?: string;
  fitContent?: boolean;
}>;

export const Drawer = ({
  children,
  isOpen = false,
  onClose,
  className,
  title = 'Drawer',
  fitContent = true,
}: DrawerProps) => (
  <Dialog open={isOpen} onClose={() => onClose?.()} className='relative z-50'>
    <DialogBackdrop
      transition
      className='fixed inset-0 bg-[var(--modal-overlay)] transition-opacity duration-150 ease-out data-closed:opacity-0'
    />

    <div className='fixed inset-0 flex items-end justify-center'>
      <DialogPanel
        transition
        className={cn(
          'pointer-events-auto w-full translate-y-0 transition-transform duration-150 ease-out data-closed:translate-y-full',
          'overflow-y-auto overscroll-contain rounded-t-2xl border-0 bg-elevated-card-2',
          'shadow-[var(--shadow-elevated)]',
          fitContent ? 'max-h-[90dvh]' : 'h-[70dvh]',
          className,
        )}
      >
        <DialogTitle className='sr-only'>{title}</DialogTitle>
        {children}
      </DialogPanel>
    </div>
  </Dialog>
);
